import { useState } from 'react';
import { parseISO, isSameDay, format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import {
    Container,
    Line,
    MessagePeriod,
    MessageWrapper
} from './styled';
import {
    Audio,
    Document,
    Error,
    Forwarded,
    Image,
    Info,
    Location,
    Response,
    Text,
    Video,
    Sticker,
    Contacts
} from './types';
import { CheckBox } from '../../components';

export function Messages(props) {

    const {
        message,
        prevMessageDate,
        openCheck,
        onChecked
    } = props;

    const [isMessageSelected, setIsMessageSelected] = useState(false)

    const formatDate = (dateString) => {
        const date = parseISO(dateString);
        const today = new Date();
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        if (isSameDay(date, today)) {
            return 'hoje';
        } else if (isSameDay(date, yesterday)) {
            return 'ontem';
        } else {
            return format(date, 'EEEE, dd/MM/yyyy', { locale: ptBR }); // Utilize o 'locale' para especificar o idioma
        }
    };
    const Separator = ({ prevMessageDate, currentDate }) => {
        const sameDay = isSameDay(parseISO(prevMessageDate), parseISO(currentDate));
        if (!sameDay) {
            return (
                <MessagePeriod>
                    <span>
                        {formatDate(currentDate)}
                    </span>
                </MessagePeriod>
            );
        } else {
            return null
        }
    };
    const RenderCheckBox = () => {
        if (message?.type === 'text' ||
            message?.type === 'template'
        ) {
            return (
                <div className='check--'>
                    <CheckBox
                        onChange={(e) => {
                            onChecked(e)
                        }
                        }
                    />
                </div>
            )
        } else {
            return null
        }
    };

    return (
        <Container isMessageSelected={isMessageSelected}>
            {openCheck && <RenderCheckBox />}
            <div className={'content-'}>
                <Separator prevMessageDate={prevMessageDate} currentDate={message.date} />
                <Line isUserSystem={message?.user_system}>
                    {message?.type === 'info'
                        ? <Info message={message} />
                        : <MessageWrapper>
                            <Error messageError={message?.error_msg}>
                                <Response
                                    message={message}
                                >
                                    <Forwarded
                                        isForwarded={
                                            message?.forwarded === 'S'
                                            || message?.frequently_forwarded === 'S'
                                        }
                                    >
                                        {message?.type === 'text' &&
                                            (<Text message={message} />)
                                        }
                                        {message?.type === 'image' &&
                                            (<Image message={message} />)
                                        }
                                        {message?.type === 'template' &&
                                            (<Text message={message} />)
                                        }
                                        {message?.type === 'voice' &&
                                            (<Audio message={message} />)
                                        }
                                        {message?.type === 'audio' &&
                                            (<Audio message={message} />)
                                        }
                                        {message?.type === 'video' &&
                                            (<Video message={message} />)
                                        }
                                        {message?.type === 'location' &&
                                            (<Location message={message} />)
                                        }
                                        {message?.type === 'document' &&
                                            (<Document message={message} />)
                                        }
                                        {message?.type === 'sticker' &&
                                            (<Sticker message={message} />)
                                        }
                                        {message?.type === 'contacts' &&
                                            <>
                                                {
                                                    message?.contacts
                                                        ? (<Contacts message={message} />)
                                                        : (<Text message={message} />)

                                                }
                                            </>
                                        }
                                    </Forwarded>
                                </Response>
                            </Error>
                        </MessageWrapper>
                    }
                </Line>
            </div>
        </Container>
    );
}